var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8654 19.0762C9.63461 19.0755 9.40643 19.0303 9.19505 18.9435C8.98367 18.8566 8.7936 18.73 8.63666 18.5714L0.456255 10.4153C0.150461 10.1099 -0.0133524 9.70312 0.000852404 9.28449C0.0150573 8.86586 0.206117 8.46967 0.532 8.18307C0.857883 7.89646 1.2919 7.74293 1.73856 7.75625C2.18522 7.76956 2.60795 7.94863 2.91374 8.25406L9.84857 15.1796L24.0044 0.665955C24.148 0.498295 24.3267 0.35993 24.5295 0.259358C24.7323 0.158786 24.9549 0.0981305 25.1836 0.0811174C25.4123 0.0641044 25.6423 0.0910929 25.8595 0.160425C26.0767 0.229757 26.2764 0.339969 26.4465 0.484291C26.6166 0.628614 26.7534 0.804 26.8485 0.999678C26.9436 1.19536 26.9951 1.40719 26.9997 1.62218C27.0043 1.83717 26.9619 2.05076 26.8752 2.24985C26.7885 2.44894 26.6593 2.62931 26.4955 2.7799L11.111 18.5556C10.9555 18.717 10.7661 18.8466 10.5547 18.9362C10.3432 19.0258 10.1143 19.0735 9.88224 19.0762H9.8654Z",
    fill: "#46B851"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.af066dd03476b92ff6352d4a2c0befb4.svg";
export { ForwardRef as ReactComponent };